import { ErrorBoundary } from '@toss/error-boundary'
import { Suspense } from 'react'

import { isWretchError } from '@/lib/types/predicate'

import { CaseInformationLoader } from '../../case-information-loader/case-information-loader'
import { ERROR_MESSAGE_MAP } from '../constants'
import { CaseInformation } from './case-information'
import { CheckCaseInformationErrorBoundary } from './check-case-information-error-boundary'

export const CheckCaseInformation = () => {
  return (
    <Suspense fallback={<CaseInformationLoader />}>
      <ErrorBoundary
        renderFallback={(error) => {
          if (isWretchError(error.error) && error.error.status === 404) {
            return <CheckCaseInformationErrorBoundary message={ERROR_MESSAGE_MAP.notFound} />
          }
          return <CheckCaseInformationErrorBoundary message={ERROR_MESSAGE_MAP.notAvailable} />
        }}
      >
        <CaseInformation />
      </ErrorBoundary>
    </Suspense>
  )
}
